var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginFail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4.16699V9.16699C15.4999 13.7961 12.3041 18.1128 8 19.167C3.69588 18.1128 0.500075 13.7961 0.5 9.16699V4.16699L8 0.833008L15.5 4.16699ZM8 9.2832L5.14258 6.42578L4 7.56836L6.85742 10.4258L4.00098 13.2822L5.14355 14.4248L8 11.5684L10.8564 14.4248L11.999 13.2822L9.14258 10.4258L12 7.56836L10.8574 6.42578L8 9.2832Z",
    fill: "#14AC63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginFail);
export default __webpack_public_path__ + "static/media/LoginFail.c7001d14bb0d13f5f015459a48499193.svg";
export { ForwardRef as ReactComponent };